import React from 'react';
import Grid from '../Grid';
import './Table.scss';

const Table = (props:any) => {
    return <div className='normalTable'><Grid
        data={props.data}
        columns={props.column}
        sort={false}
        pagination={false}
        globalSearch= {false}
        className={props.className}
         data-attribute="index_Default_Grid" /></div>
}

export default Table;